import { axiosClient } from "@/api/axios";

export function getCoursesData() {
  return axiosClient.get("course-catalog");
}
